import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { wrapDisplayName } from '../displayName';

/**
 * Функция для создания именованного React-контекста гарантирующего наличие значения
 * При попытке получить значение без его инициализации выбрасывает исключение
 *
 * Принимает:
 * * contextName
 *
 * Возвращает объект с:
 * * Context - сам контекст
 * * useContext - хук для получения значения контекста
 * * withContext - HOC-фабрика для проброса контекста в пропсы
 *
 * @export
 * @template T тип или интерфейс значения
 * @param {IMakeContextModuleOptions<T>} options
 * @param {string} options.contextName название контекста в CamelCase
 * @param {T} [options.defaultValue] значение по умолчанию
 */
export function makeContextModule(options) {
  var defaultValue = options.defaultValue,
      contextName = options.contextName;
  var Context = /*#__PURE__*/React.createContext(defaultValue);
  Context.displayName = contextName;

  var useContext = function useContext() {
    var context = React.useContext(Context);

    if (typeof context === 'undefined') {
      throw new Error("\u041F\u043E\u043F\u044B\u0442\u043A\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C use".concat(contextName, " \u0432\u043D\u0435 \u043A\u043E\u043D\u0442\u0435\u043A\u0441\u0442\u0430 \u0438\u043B\u0438 \u0431\u0435\u0437 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F \u043F\u043E \u0443\u043C\u043E\u043B\u0447\u0430\u043D\u0438\u044E"));
    }

    return context;
  };

  function withContext(mapContextToProps) {
    return function (Component) {
      function WithContext(props) {
        var context = useContext();
        var contextProps = mapContextToProps(context);
        return /*#__PURE__*/React.createElement(Component, _extends({}, props, contextProps));
      }

      WithContext.displayName = wrapDisplayName(Component, "with".concat(contextName));
      return WithContext;
    };
  }

  return {
    Context: Context,
    useContext: useContext,
    withContext: withContext
  };
}